/**
 * Competitor Pricing — Route configuration.
 *
 * Single source of truth for the Marketplace Price Competitiveness domain:
 *
 *   - MPCS_BASE — feature root path
 *   - ROUTES — named static routes
 *   - MPCS_API_ENDPOINTS — BFF API URLs
 *
 * The page is reachable by direct URL only — there is no side-nav entry, by
 * design (the side nav is reserved for Value Matching).
 *
 * Single-page feature: one route, one API endpoint.
 */

export const MPCS_BASE = '/marketplace-price-competitiveness';

export const ROUTES = {
  HOME: MPCS_BASE,
} as const;

export const MPCS_API_ENDPOINTS = {
  GET_COMPETITOR_PRICING: '/mpcs-api/v1/get-competitor-pricing',
} as const;
